import request from '@/utils/request'

export function puchaseGoods(data) {
  return request({
    url: '/order/buy',
    method: 'post',
    params: data
  })
}

export function createJSApi(data) {
  return request({
    url: '/cart/order/createJSApi',
    method: 'post',
    data
  })
}

export function fetchOrders(data) {
  return request({
    url: '/order/search/my',
    method: 'get',
    params: data
  })
}

export function pushGoods(orderId) {
  return request({
    url: '/order/pay/getGoods/' + orderId,
    method: 'get'
  })
}

export function getJsSdkConfig() {
  return request({
    url: '/order/getJsSdkConfig?url=' + location.href,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js